import React from 'react';
import type { JourneyStage } from '../../data/crm';
import { JourneyIllustration } from './JourneyIllustration';
type StagePanelProps = {
  stage: JourneyStage;
  showHeading?: boolean;
};
export function StagePanel({
  stage,
  showHeading = true
}: StagePanelProps) {
  return <div className="grid gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-308" data-mp="203zs0gpxo1dx">
      <div className="lg:col-span-8" data-id="element-309" data-mp="205kkm0sota95">
        {showHeading && <>
            <h3 className="text-2xl font-extrabold tracking-tight text-brand-black sm:text-3xl" data-id="element-310" data-mp="2521c94z3i6qz">{stage.headline}</h3>
            <p className="mt-2 text-lg text-gray-600" data-id="element-311" data-mp="2933apjl6uerw">{stage.sub}</p>
          </>}
        <ul className={`grid gap-x-8 gap-y-6 sm:grid-cols-2 ${showHeading ? 'mt-8' : ''}`} data-id="element-312" data-mp="2e52c4nxdb1m7">
          {stage.features.map(feature => <li key={feature.name} className="flex gap-3" data-id="element-313" data-mp="2j0ho1abtenfz">
              <feature.icon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand-red" strokeWidth={1.75} aria-hidden="true" data-id="element-314" data-mp="jrawn7scxniu" />
              <div data-id="element-315" data-mp="oqxb1kjx99t8">
                <p className="text-sm font-bold text-brand-black" data-id="element-316" data-mp="gh13fi93wk3g">{feature.name}</p>
                <p className="mt-1 text-sm leading-relaxed text-gray-600" data-id="element-317" data-mp="givqb23xuma6">{feature.outcome}</p>
              </div>
            </li>)}
        </ul>
      </div>
      <div className="lg:col-span-4" data-id="element-318" data-mp="6s0zdkfqyyie">
        <JourneyIllustration stage={stage.id} data-id="element-319" data-mp="6ovfqkpw0ou2" />
      </div>
    </div>;
}